const UserType = Object.freeze({
  Individual: 'Individual',
  Company: 'Company',
});

const QuoteBy = Object.freeze({
  SendAmount: 'SendAmount',
  ReceiveAmount: 'ReceiveAmount',
});

const PaymentPurpose = Object.freeze({
  CharitableContributions: 'CharitableContributions',
  EducationFees: 'EducationFees',
  EmployeeSalariesOrWages: 'EmployeeSalariesOrWages',
  FamilyAndFriendsSupport: 'FamilyAndFriendsSupport',
  Gifts: 'Gifts',
  Insurance: 'Insurance',
  IntercompanyTransfer: 'IntercompanyTransfer',
  Investments: 'Investments',
  Loans: 'Loans',
  PersonalTransfers: 'PersonalTransfers',
  PurchaseOfGoods: 'PurchaseOfGoods',
  PurchaseOfServices: 'PurchaseOfServices',
  RealEstate: 'RealEstate',
  Rent: 'Rent',
  Taxes: 'Taxes',
  Travel: 'Travel',
  UtilityBills: 'UtilityBills',
});

const DocumentType = Object.freeze({
  Compliance: 'Compliance',
  CrossBorder: 'CrossBorder',
});

export { UserType, QuoteBy, PaymentPurpose, DocumentType };
